<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1">
        <div class="bg-gray-200 p-3 br-15">
            <div class="tableHolder table-responsive custom-table">
                <table mat-table [dataSource]="dataSource" class="table">
                    <!-- date -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.startDate | date: 'medium' }}
                        </td>
                    </ng-container>

                    <!-- campaign_name -->
                    <ng-container matColumnDef="campaignName">
                        <th mat-header-cell *matHeaderCellDef>Campaign Name</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.title }}
                        </td>
                    </ng-container>

                    <!-- issuer_name -->
                    <ng-container matColumnDef="issuerName">
                        <th mat-header-cell *matHeaderCellDef>Issuer Name</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.issuerName }}
                        </td>
                    </ng-container>

                    <!-- campaign_price -->
                    <ng-container matColumnDef="campaignPrice">
                        <th mat-header-cell *matHeaderCellDef>Campaign Price</th>
                        <td mat-cell *matCellDef="let element">
                            {{
                            element.campaignTotalPrice
                            ? (element.campaignTotalPrice.value
                            | currency: element.campaignTotalPrice.currencyCode)
                            : ''
                            }}
                        </td>
                    </ng-container>

                    <!-- charges -->
                    <ng-container matColumnDef="charges">
                        <th mat-header-cell *matHeaderCellDef>Charges</th>
                        <td mat-cell *matCellDef="let element">
                            {{
                            getMfCharges(element)
                            | currency: element.campaignTotalPrice?.currencyCode
                            }}
                        </td>
                    </ng-container>

                    <!-- vat -->
                    <ng-container matColumnDef="vat">
                        <th mat-header-cell *matHeaderCellDef>VAT</th>
                        <td mat-cell *matCellDef="let element">
                            {{
                            element.campaignTotalPrice
                            ? (((element.campaignTotalPrice.value +
                            element.totalMunicipalityFees) *
                            vat) /
                            100 | currency: element.campaignTotalPrice.currencyCode)
                            : ''
                            }}
                        </td>
                    </ng-container>

                    <!-- total_campaign_fees -->
                    <ng-container matColumnDef="totalCampaignFees">
                        <th mat-header-cell *matHeaderCellDef>Total Campaign Fees</th>
                        <td mat-cell *matCellDef="let element">
                            {{
                            element.campaignTotalPrice
                            ? (getCampaignTotalFees(
                            element.campaignTotalPrice.value +
                            element.totalMunicipalityFees,
                            getMfCharges(element)
                            ) | currency: element.campaignTotalPrice.currencyCode)
                            : ''
                            }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"
                        (click)="getCampaignTransactionHistory(row._id)" class="clickable-row"></tr>
                </table>
                <mat-paginator [length]="paginator.length" [pageSizeOptions]="[5, 10, 20]" pageSize="5"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>